import React, { useEffect, useState } from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import AlternativeProduct from './AlternativeProduct'
import "./ProductDetailRight.styles.css";
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  WhatsappShareButton,
  WhatsappIcon
} from "react-share";

const ProductDetailRight = ({ productDetail, shareLink }) => {

const [productDetails, setProductDetails] = useState(null);
const [qty, setQty] = useState(1);
const [wishlisted, setWishlisted] = useState(false);
const [shareUrl, setShareUrl] = useState('');

const addToWishlist = async (matnum,wishlist) => {
  if(wishlist){
    await AuthVerify.removeFromWishlist(matnum);
  }else{
    await AuthVerify.addToWishlist(matnum);
  }
  setWishlisted(!wishlisted);
}

useEffect(async () => {
  setShareUrl(shareLink);
}, [shareLink])

useEffect(async () => {
  if(productDetail.matm.wishlist)setWishlisted(true);
  setProductDetails(productDetail);
}, [productDetail])

return (
<>
  {
  productDetails!=null && productDetails.matm!=null?
  <>
  {/* <div className="product-next-prev">
      <Link className="product-next" to="/product-detail">
      <span></span>
      </Link>
      <Link className="product-prev" to="/product-detail">
      <span></span>
      </Link>
    </div> */}
    <div className="product-name">
      <h1>{productDetails.matm.matname}</h1>
    </div>
    <div className="rating">
    <i className={productDetails.matm.rating>0?"fa fa-star":"fa fa-star-o"}></i>
    <i className={productDetails.matm.rating>1?"fa fa-star":"fa fa-star-o"}></i>
    <i className={productDetails.matm.rating>2?"fa fa-star":"fa fa-star-o"}></i>
    <i className={productDetails.matm.rating>3?"fa fa-star":"fa fa-star-o"}></i>
    <i className={productDetails.matm.rating>4?"fa fa-star":"fa fa-star-o"}></i>
      <p className="rating-links">
        <Link to="/product-detail">4 Review(s)</Link>
        <span className="separator">|</span>
        <Link to="/product-detail">
        <i className="fa fa-pencil"></i> write a review
        </Link>
      </p>
    </div>
    <div className="price-block">
      <div className="price-box">
        <p className="special-price">
          <span className="price-label">Special Price</span>
          <span id="product-price-48" className="price">
            S${productDetails.matm.sellingprice?.toFixed(2)} (w/GST S${productDetails.matm.gstprice?.toFixed(2)}) 
          </span>
        </p>
        {productDetails.matm.promoprice && 
        <>
        <br />
        <p className="old-price">
          <span className="price-label">Regular Price:</span>
          <span className="price">U.P. S${productDetails.matm.usualprice.toFixed(2)}</span>
        </p>
        </>
        }
        {productDetails.matm.usualprice != productDetails.matm.sellingprice && !productDetails.matm.promoprice && false &&
        <>
        <br />
        <p className="old-price">
          <span className="price-label">Regular Price:</span>
          <span className="price">U.P. S${productDetails.matm.usualprice?.toFixed(2)}</span>
        </p>
        </>
        }
      </div>
    </div>
    <div className="info-orther">
      <p>Item Code: {productDetails.matm.matnum}</p>
      {/* <p>
        Availability: <span className="in-stock">{productDetails.matm.availability || "In stock"}</span>
      </p>
      <p>Condition: {productDetails.matm.productType || "New"}</p> */}
    </div>
    <div className="short-description">
      <h2>Quick Overview</h2>
      <ul style={{listStyleType:"circle",marginLeft:"10px"}}>
        {productDetails.description && productDetails.description.map((item,i)=>{
          return (<li key={i}>{item.itemdesc}</li>)
        })}
      </ul>
      <p>
        {productDetails.matm.extraOffer}
      </p>
    </div>
    <div className="form-share">
      <div className="sendtofriend-print">
        {/* <Link to="/product-detail">
        <i className="fa fa-print"></i> Print
        </Link> */}
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={25} round={true}/>
        </FacebookShareButton>
        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon size={25} round={true}/>
        </WhatsappShareButton>
        <EmailShareButton url={shareUrl}>
          <EmailIcon size={25} round={true}/>
        </EmailShareButton>
        <TelegramShareButton url={shareUrl}>
          <TelegramIcon size={25} round={true}/>
        </TelegramShareButton>        {/* <div>
        <i className="fa fa-envelope-o fa-fw"></i> Send to a friend
        </div> */}
      </div>
    </div>
    <div className="form-option">
      <p className="form-option-title">Available Options:</p>
      <div className="attributes">
        <div className="attribute-label" style={{ float: "none" }}>Colour/Size/Type:</div>
        <div className="attribute-list">
          {/* <ul className="list-color"> */}
          <ul className="list-color-new">
            {
              productDetails?.colours ?
              productDetails.colours.map((colour,i) => (
                <li key={i}>
                  <Link to={"/product-detail?matnum="+colour?.matnum}>{colour.varname}</Link>
                </li>
              ))
              : 
              <li style={{display:"contents"}}>No colour is available</li>
            }
          </ul>
        </div>
      </div>
      <div className="add-to-box">
        <div className="add-to-cart d-flex">
          <div className="custom pull-left">
            <label>Qty :</label>
            <button className="reduced items-count" type="button" onClick={()=>{if(qty>1)setQty(qty-1)}}>
              <i className="fa fa-minus">&nbsp;</i>
            </button>
            <input type="text" className="input-text qty" title="Qty" value={qty} maxLength="12" id="qty" name="qty" onChange={(e)=>setQty(e.target.value)}/>
            <button className="increase items-count" type="button" onClick={()=>{if(qty<12)setQty(qty+1)}}>
              <i className="fa fa-plus">&nbsp;</i>
            </button>
          </div>
          <div className="email-addto-box">
            <ul className="add-to-links">
              <li>
                <button className={`link-wishlist ${wishlisted?'active':''}`} onClick={()=>{addToWishlist(productDetails.matm.matnum,wishlisted)}}>
                  <span>Add to Wishlist</span>
                </button>
              </li>
              {/* <li>
                <span className="separator">|</span>
                <Link className="link-compare" to="/product-detail">
                <span>Add to Compare</span>
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
        <div className="">
          <button className="button btn-cart" title="Add to Cart" type="button" onClick={()=>AuthVerify.addTocart(productDetails.matm,{qty:qty})}>
            Add to Cart
          </button>
          <br />
          <br />
          <br />
          <small style={{ textTransform: "none", color: "red", marginTop: "5px !important" }}>
            {productDetails?.matm?.qohmsg}
          </small>
        </div>
      </div>
    </div>
    {
      productDetails.alternatives && 
      <>
      <br />
      <h4 className="form-option-title">
        You may also want to look at alternative products:
      </h4>
    <div className="product-image">
      <div className="more-views">
        <div className="slider-items-products1">
          <div className="product-flexslider hidden-buttons product-img-thumb">
            <div className="slider-items slider-width-col4 block-content">
              {/* <RenderRevData data={productDetails}/> */}
              <AlternativeProduct data={productDetails}/>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
    
  }
  
  {productDetails?.catalog && 
    <div className="recent-orders">
    <div className="title-buttons"><strong>Catalog Information</strong>
      <Link to="/product-detail">Add to Catalog</Link>
    </div>
    <div className="table-responsive">
      <table className="data-table" id="my-orders-table">
        <thead>
          <tr className="first last">
            <th>Catalog</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {productDetails.catalog.map((catalog,i)=>{
            return (<tr className="first odd" key={i}>
              <td>{catalog.catalogname}</td>
              <td className="a-center last"><span className="nobr">
                  <Link to="/product-detail">View</Link> <span className="separator">| </span>
                  <Link to="/product-detail">Delete</Link> </span></td>
            </tr>)
          })}
          
          {/* <tr className="last even">
            <td>Catalog 2</td>
            <td className="a-center last"><span className="nobr">
                <Link to="/product-detail">View</Link> <span className="separator">|</span>
                <Link to="/product-detail">Delete</Link> </span></td>
          </tr> */}
        </tbody>
      </table>
    </div>
  </div>
  }
    
  </>:<>
    {/* <div className="product-next-prev">
      <Link className="product-next" to="/product-detail">
      <span></span>
      </Link>
      <Link className="product-prev" to="/product-detail">
      <span></span>
      </Link>
    </div>
    <div className="product-name">
      <h1>{productDetail?.productTitle || "TruSens Z-1000 Air Purifier (FOC Carbon & Hepa Filter)"}</h1>
    </div>
    <div className="rating">
      <i className="fa fa-star"></i> <i className="fa fa-star"></i>
      <i className="fa fa-star"></i> <i className="fa fa-star"></i>
      <i className="fa fa-star-o"></i>
      <p className="rating-links">
        <Link to="/product-detail">4 Review(s)</Link>
        <span className="separator">|</span>
        <Link to="/product-detail">
        <i className="fa fa-pencil"></i> write a review
        </Link>
      </p>
    </div>
    <div className="price-block">
      <div className="price-box">
        <p className="special-price">
          <span className="price-label">Special Price</span>
          <span id="product-price-48" className="price">
            {productDetail?.price || "S$193.46 w/GST S$207.00"}
          </span>
        </p>
        <br />
        <p className="old-price">
          <span className="price-label">Regular Price:</span>
          <span className="price">was S$ 215.00</span>
        </p>
      </div>
    </div>
    <div className="info-orther">
      <p>Item Code: {'#' + productDetail?.itemCode || "#12345678"}</p>
      <p>
        Availability: <span className="in-stock">{productDetail?.availability || "In stock"}</span>
      </p>
      <p>Condition: {productDetail?.productType || "New"}</p>
    </div>
    <div className="short-description">
      <h2>Quick Overview</h2>
      <p>
        {productDetail?.description || "Technologically advanced air purifier with DuPont filtration reduces pollutants in your personal space and improves your home air quality. The sleek design and compact style are ideal for any small space"}
        <br />
        <br />
        {productDetail?.extraOffer || "Limited Promotions :Free 1 box of carbon filter and 1 box of Hepa filter"}
      </p>
    </div>
    <div className="form-share">
      <div className="sendtofriend-print">
        <Link to="/product-detail">
        <i className="fa fa-print"></i> Print
        </Link>
        <Link to="/product-detail">
        <i className="fa fa-envelope-o fa-fw"></i> Send to a friend
        </Link>
      </div>
    </div>
    <div className="heading-counter danger text-center" style={{
          margin: "20px 0",
          padding: "15px",
          border: "1px solid #a94442",
          backgroundColor: "#fff",
          color: "#a94442",
        }}>
      <span>
        <strong>Item is not in current catalog</strong>
      </span>
    </div>
    <div className="form-option">
      <p className="form-option-title">Available Options:</p>
      <div className="attributes">
        <div className="attribute-label">Color:</div>
        <div className="attribute-list">
          <ul className="list-color">
            <li style={{ background: "#6e6b6b" }}>
              <Link to="/product-detail">Grey</Link>
            </li>
            <li style={{ background: "#000000" }}>
              <Link to="/product-detail">Black</Link>
            </li>
            <li style={{ background: "#ffffff" }} className="active">
              <Link to="/product-detail">White</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="add-to-box">
        <div className="add-to-cart d-flex">
          <div className="custom pull-left">
            <label>Qty :</label>
            <button className="reduced items-count" type="button">
              <i className="fa fa-minus">&nbsp;</i>
            </button>
            <input type="text" className="input-text qty" title="Qty" value="1" maxLength="12" id="qty" name="qty" />
            <button className="increase items-count" type="button">
              <i className="fa fa-plus">&nbsp;</i>
            </button>
          </div>
          <div className="email-addto-box">
            <ul className="add-to-links">
              <li>
                <Link className="link-wishlist" to="/product-detail">
                <span>Add to Wishlist</span>
                </Link>
              </li>
              <li>
                <span className="separator">|</span>
                <Link className="link-compare" to="/product-detail">
                <span>Add to Compare</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="">
          <button className="button btn-cart" title="Add to Cart" type="button">
            Add to Cart
          </button>
          <br />
          <br />
          <br />
          <small style={{ textTransform: "none", color: "red", marginTop: "5px !important" }}>
            ** Please note that the Qty you are ordering exceed our Stock On
            Hand, there may be a delay in delivery.
          </small>
        </div>
      </div>


      <br />
      <h4 className="form-option-title">
        You may also want to look at alernative products:
      </h4>
    </div>
    <div className="product-image">
      <div className="more-views">
        <div className="slider-items-products1">
          <div className="product-flexslider hidden-buttons product-img-thumb">
            <div className="slider-items slider-width-col4 block-content">
              <OwlCarousel className="product-flexslider hidden-buttons owl-theme" {...options}>
                <div style={{ padding: '10px' }} className="more-views-items">
                  <a href="/product-details" data-image="images/products/img05.jpg"
                    data-zoom-image="images/products/img02.jpg">
                    <img id="product-zoom" src="images/products/img05.jpg" alt="product-image" /> </a></div>
                <div style={{ padding: '10px' }} className="more-views-items">
                  <a href="/product-details" data-image="images/products/img06.jpg"
                    data-zoom-image="images/products/img03.jpg">
                    <img id="product-zoom" src="images/products/img06.jpg" alt="product-image" /> </a></div>
                <div style={{ padding: '10px' }} className="more-views-items">
                  <a href="/product-details" data-image="images/products/img07.jpg"
                    data-zoom-image="images/products/img04.jpg">
                    <img id="product-zoom" src="images/products/img07.jpg" alt="product-image" /> </a></div>
                <div style={{ padding: '10px' }} className="more-views-items">
                  <a href="/product-details" data-image="images/products/img08.jpg"
                    data-zoom-image="images/products/img05.jpg">
                    <img id="product-zoom" src="images/products/img08.jpg" alt="product-image" /> </a> </div>
                <div style={{ padding: '10px' }} className="more-views-items">
                  <a href="/product-details" data-image="images/products/img09.jpg"
                    data-zoom-image="images/products/img06.jpg">
                    <img id="product-zoom" src="images/products/img01.jpg" alt="product-image" /> </a></div>
              </OwlCarousel>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="recent-orders">
      <div className="title-buttons"><strong>Catalog Information</strong>
        <Link to="/product-detail">Add to Catalog</Link>
      </div>
      <div className="table-responsive">
        <table className="data-table" id="my-orders-table">
          <thead>
            <tr className="first last">
              <th>Catalog</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr className="first odd">
              <td>Catalog 1</td>
              <td className="a-center last"><span className="nobr">
                  <Link to="/product-detail">View</Link> <span className="separator">|</span>
                  <Link to="/product-detail">Delete</Link> </span></td>
            </tr>
            <tr className="last even">
              <td>Catalog 2</td>
              <td className="a-center last"><span className="nobr">
                  <Link to="/product-detail">View</Link> <span className="separator">|</span>
                  <Link to="/product-detail">Delete</Link> </span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> */}
  </>
  }
</>
);
};

export default ProductDetailRight;